const editDefault: boolean = true;

export class Options {
  edit: boolean = editDefault;

  constructor() {  }
}
